import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles the redirect back from Emergent Google Auth.
 * The URL will contain `#session_id=...` — we exchange it once for a
 * persistent session cookie, then clean up the URL and land the user
 * back where they came from (or home).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { completeReaderSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    const finish = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        await completeReaderSession(sessionId);
        toast.success("Welcome! You're signed in.");
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
      } finally {
        // Strip the hash so we never re-process it
        navigate("/", { replace: true });
      }
    };
    finish();
     
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="auth-callback"
      style={{ background: "#FDFBF7" }}
    >
      <div className="font-fredoka text-xl" style={{ color: "#2D3055" }}>
        Signing you in…
      </div>
    </div>
  );
}
